import BulkDeletePOSpecs from "./BulkDeletePOSpecs";
export default BulkDeletePOSpecs;
